import { render, staticRenderFns } from "./TaxGroupsList.vue?vue&type=template&id=4c241490&scoped=true&"
import script from "./TaxGroupsList.vue?vue&type=script&lang=js&"
export * from "./TaxGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./TaxGroupsList.vue?vue&type=style&index=0&id=4c241490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c241490",
  null
  
)

export default component.exports